/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApolloClient } from '@apollo/client/index.js';
import { from } from '@apollo/client/link/core/from.js';
import { HttpLink } from '@apollo/client/link/http/HttpLink.js';
import { createErrorLink } from './createErrorLink.js';
import { createAuthLink } from './createAuthLink.js';
import { createWsHttpLink } from './createWsHttpLink.js';
/**
 * Default implementation of a browser side IApolloClientFactory
 * */
export class ApolloClientFactory {
    /**
     * Creates a browser side Apollo client factory
     * @param customArgs
     */
    constructor(customArgs) {
        this._webSocketProtocol = 'subscriptions-transport-ws';
        this._initialState = customArgs.initialState;
        this._webSocketLinkConfig = customArgs._webSocketLinkConfig;
        this._wsClientOptions = customArgs._wsClientOptions;
        this._loginUrl = customArgs.loginUrl;
        this._errorUrl = customArgs.errorUrl;
        this._graphBasePath = customArgs.graphBasePath;
        this._graphUri = customArgs.graphUri;
        this._webSocketUri = customArgs.webSocketUri;
        this._envCookieName = customArgs.envCookieName;
        this._csrfTokenName = customArgs.csrfTokenName;
        this._webSocketProtocol = customArgs.webSocketProtocol;
        if ('errorLink' in customArgs) {
            // errorLink can be undefined, allowing users to configure
            // Apollo client with no error link in their link chain
            if (customArgs.errorLink) {
                this._errorLink = customArgs.errorLink;
            }
        }
        else {
            this._errorLink = createErrorLink(this._graphBasePath, { errorPageUrl: this._errorUrl });
        }
    }
    createClient(options) {
        const httpLink = options.link ||
            new HttpLink({
                uri: this._graphUri
            });
        const cache = options.cache.restore(this._initialState || {});
        const links = [
            createAuthLink(this._envCookieName, this._csrfTokenName, this._loginUrl),
            this._errorLink,
            typeof window !== 'undefined'
                ? createWsHttpLink(httpLink, this._webSocketUri, this._wsClientOptions, this._webSocketLinkConfig, this._webSocketProtocol)
                : httpLink
        ].filter(Boolean);
        return new ApolloClient({
            ssrMode: false,
            link: from(links),
            ...options,
            cache
        });
    }
}
//# sourceMappingURL=ApolloClientFactory.js.map